export function updateBroadcastState(state, payload) {
  state[payload.state] = payload.data;
}
